import { useQuery } from '@tanstack/react-query';
import { companyService } from '../services/company.service';
import type { Company } from '../types/company.types';

export function useCompany(id: string | undefined): {
  company: Company | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
} {
  const query = useQuery({
    queryKey: ['company', id],
    queryFn: () => companyService.getCompanyById(id!),
    enabled: !!id,
  });

  return {
    company: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
